export default "__VITE_ASSET__N5bF0fxA__"